



















// @ is an alias to /src
import { Component } from "vue-property-decorator";
import Dialog from "@/components/Dialog.vue";
import ErrorList from "@/components/ErrorList.vue";
import HacoCommon from "../HacoCommon";
import PrinterEditComp from "@/components/PrinterEditComp.vue";
@Component({
  components: {
    PrinterEditComp,
    Dialog,
    ErrorList
  }
})
export default class PrinterEdit extends HacoCommon {
  // put something
}
